import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
  AgencyCMSSetting,
  AgencyCMSSettingUpdateRequest,
  AgencyCreditByReasonResponse,
  CMSHistoryStatsResponse,
  CreditStatus,
  DailyAutomationCMSHistoryStatsRequest
} from "fello-model";
import {Observable} from "rxjs";
import {PAYMENT_API_SERVICE_BASE_URL} from "../payment";

@Injectable({
  providedIn: "root"
})
export class AgentCmsApiService {
  baseUrl: string;
  constructor(private http: HttpClient, @Inject(PAYMENT_API_SERVICE_BASE_URL) private paymentBaseUrl: string) {
    this.baseUrl = `${this.paymentBaseUrl}/payment/cms/agent`;
  }

  updateCMSSetting(updateRequest: AgencyCMSSettingUpdateRequest): Observable<unknown> {
    return this.http.patch(`${this.baseUrl}/setting`, updateRequest);
  }

  getAgencyCMSSetting(): Observable<AgencyCMSSetting> {
    return this.http.get<AgencyCMSSetting>(`${this.baseUrl}/setting`);
  }

  getCreditStatus(): Observable<CreditStatus> {
    return this.http.get<CreditStatus>(`${this.baseUrl}/credit/status`);
  }

  getAutomationCreditStats(automationDefId: string, params: DailyAutomationCMSHistoryStatsRequest): Observable<CMSHistoryStatsResponse[]> {
    return this.http.post<CMSHistoryStatsResponse[]>(`${this.baseUrl}/automation/${automationDefId}/credit/stats`, {
      params
    });
  }

  getCreditUsage(dateFrom: string, automationId?: string): Observable<AgencyCreditByReasonResponse> {
    const params: Record<string, string> = {
      dateFrom
    };
    if (automationId) {
      params.automationId = automationId;
    }
    return this.http.get<AgencyCreditByReasonResponse>(`${this.baseUrl}/credit/debit/history`, {
      params
    });
  }
}
